import { Component, output, ChangeDetectionStrategy, effect } from '@angular/core';
import { AbstractDynamicReportViewComponent } from '../../abstract/abstract-dynamic-report-view.component';
import { groupByProperty } from '../../shared/utils/group-by-property';
import { EditableFieldsService } from '../editable-fields.service';
import { ReportRecord, ReportInfo } from '../../models/report.model';
import { ActionsToolbarComponent } from '../presentation-view/actions-toolbar/actions-toolbar.component';
import { DynamicContactsComponent } from './dynamic-contacts/dynamic-contacts.component';
import { PresentationDynamicViewBodyComponent } from './record-body/record-body.component';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rep-presentation-dynamic-view',
  templateUrl: './presentation-dynamic-view.component.html',
  styleUrl: './presentation-dynamic-view.component.scss',
  providers: [EditableFieldsService],
  imports: [ActionsToolbarComponent, DynamicContactsComponent, PresentationDynamicViewBodyComponent],
})
export class PresentationDynamicViewComponent extends AbstractDynamicReportViewComponent {
  recordNumber: number;
  recordsCount: number;
  reportRecordsData: ReportInfo;
  readonly removeRecord = output<ReportRecord>();
  readonly reportReordered = output<ReportRecord[]>();

  constructor() {
    super();
    effect(() => {
      const reportData = this.reportData();
      const currentView = this.currentView();
      // TODO: Need to remove templateid check to groupby property records once receives groupby from BE "views/9/templates" API
      if (!!reportData && reportData.records && !!currentView && currentView.templateId === 16) {
        const groupRecordsByEntity = groupByProperty(reportData.records) as ReportRecord[];
        this.recordsCount = !!reportData && !!groupRecordsByEntity ? groupRecordsByEntity.length : null;
        this.reportRecordsData = { ...reportData, records: groupRecordsByEntity };
      } else if (!!currentView) {
        this.recordsCount = !!reportData && !!reportData.records ? reportData.records.length : null;
        this.reportRecordsData = reportData;
      }
    });
  }

  navRecordNum(recordNumber: number) {
    this.recordNumber = recordNumber;
  }
}
